import { useMutation } from "@tanstack/react-query";

type UploadToSignedUrlInput = {
  uploadUrl: string;
  file: Blob;
  contentType?: string;
};

export function useUploadToSignedUrlMutation() {
  const mutation = useMutation({
    mutationFn: async ({ uploadUrl, file, contentType }: UploadToSignedUrlInput) => {
      const response = await fetch(uploadUrl, {
        method: "PUT",
        headers: contentType ? { "Content-Type": contentType } : undefined,
        body: file,
      });

      if (!response.ok) {
        throw new Error("Signed URL upload failed");
      }

      return response;
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
